// extracted by mini-css-extract-plugin
export default {"themeSwitch":"layoutStyles_themeSwitch__8yZ3+","OTPContainer":"layoutStyles_OTPContainer__-KjBC","box":"layoutStyles_box__8nLHY"};